import React from 'react'
import { Row, Col, Statistic, Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { ContainerStyleCol } from 'components/Common'

export type LoyaltyStatTypes = {
  loyaltyCustomers: number
  stampsEarned: number
  rewardsEarned: number
  rewardsRedeemed: number
  totalSpent: number
  averageBasketSize: number
}

type StatConfig = {
  value: number
  label: string
  tooltip: string
  prefix?: string
  precision?: number
}

const LoyaltyStats = ({
  loyaltyCustomers,
  stampsEarned,
  rewardsEarned,
  rewardsRedeemed,
  totalSpent,
  averageBasketSize
}: LoyaltyStatTypes) => {
  const stats: StatConfig[] = [
    {
      value: loyaltyCustomers,
      label: 'CUSTOMERS',
      tooltip:
        'Number of customers who have collected loyalty points during the selected time period'
    },
    {
      value: stampsEarned,
      label: 'STAMPS EARNED',
      tooltip: 'Total stamps earned during the selected time period'
    },
    {
      value: rewardsEarned,
      label: 'REWARDS EARNED',
      tooltip:
        'Total rewards currently available to redeem across all loyalty customers'
    },
    {
      value: rewardsRedeemed,
      label: 'REWARDS REDEEMED',
      tooltip: 'Number of rewards redeemed during the selected time period'
    },
    {
      value: totalSpent,
      label: 'TOTAL SPENT',
      tooltip: 'Total £ spent by loyalty customers in the selected time period',
      prefix: '£',
      precision: 2
    },
    {
      value: averageBasketSize,
      label: 'AVERAGE BASKET SIZE',
      tooltip:
        'Average order size for loyalty customers in the selected time period',
      prefix: '£',
      precision: 2
    }
  ]

  return (
    <Row data-testid='loyaltyStats' justify='center'>
      <ContainerStyleCol className='_pl-0 _pr-0' flex='0 0 100%'>
        <Row className='_pt-24 _pr-8 _pb-32 _pl-8 _mb-0' justify='space-around'>
          {stats.map(({ value, label, tooltip, prefix, precision }) => (
            <Col key={label} span={4} className='_text-center'>
              <Statistic
                value={value}
                prefix={prefix}
                precision={precision}
                className='_mb-16'
              />
              <div className='_cl-text-secondary'>
                {label}
                <Tooltip title={tooltip}>
                  <QuestionCircleOutlined className='_ml-4' />
                </Tooltip>
              </div>
            </Col>
          ))}
        </Row>
      </ContainerStyleCol>
    </Row>
  )
}

export default LoyaltyStats
